import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AuthState } from 'src/shared/store/state/auth.state';

import { environment } from '../../environments/environment';
import { SubUrlsEnum } from '../../shared/enums/sub-urls.enum';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
    constructor(private store: Store, private translate: TranslateService) {}

    private headerConfig: any = {
        ['Content-Type']: 'application/json;charset=UTF-8',
        ['x-api-key']: environment.apiKey,
    };

    private blackListedServicesParams: any[] = [
        'assets/locales',
        SubUrlsEnum.LOGIN,
        SubUrlsEnum.REFRESH_TOKEN,
        SubUrlsEnum.LOGOUT,
        SubUrlsEnum.RESET_PWD,
        SubUrlsEnum.CREATE_PWD,
        SubUrlsEnum.RECOVERY_PWD,
        SubUrlsEnum.SCHOOLS,
        SubUrlsEnum.ROLES,
        SubUrlsEnum.GENDERS,
        SubUrlsEnum.EDUCATION_LEVELS,
        SubUrlsEnum.EDUCATION_TYPES,
        SubUrlsEnum.COSTS_REPARTITION,
        SubUrlsEnum.CLASS_TYPES,
        SubUrlsEnum.RATE_TYPES,
        SubUrlsEnum.CUSTODY_TYPES,
        SubUrlsEnum.RELATIVE_TYPES,
        SubUrlsEnum.CONTACT_TYPES,
        SubUrlsEnum.CREDIT_TYPES,
        SubUrlsEnum.SUPPORT,
        SubUrlsEnum.PAYMENT_INTENT,
        SubUrlsEnum.STORAGE_TYPES,
        SubUrlsEnum.IMPORT_USERS,
        SubUrlsEnum.IMPORT_WALLET,
    ];

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Build headers from headerConfig
        let headers: HttpHeaders = Object.keys(this.headerConfig).reduce(
            (currentHeader: HttpHeaders, k: string) => currentHeader.set(k, this.headerConfig[k]),
            new HttpHeaders()
        );
        req.headers.keys().forEach((key: string) => {
            headers = headers.set(key, req.headers.get(key));
        });

        const token: string = this.store.selectSnapshot(AuthState.accessToken);
        if (token) {
            headers = headers.set('Authorization', `Bearer ${token}`);
        }

        if (this.translate.currentLang) {
            headers = headers.set('lang', this.translate.currentLang);
        }

        if (req.headers.get('Content-Type') === 'multipart/form-data') {
            headers = headers.delete('Content-Type');
        }

        // Build params
        let params: HttpParams = new HttpParams();
        req.params.keys().forEach((key: string) => {
            req.params.getAll(key).forEach((value: string) => {
                params = params.append(key, value);
            });
        });
        if (!this.blackListedServicesParams.some((subUrl: string) => req.url.includes(subUrl))) {
            const schoolId: number = this.store.selectSnapshot(AuthState.currentSchool)?.id;
            if (schoolId) {
                params = params.set('school_id', schoolId);
            }
        }
        const authReq: HttpRequest<any> = req.clone({ headers, params });
        return next.handle(authReq);
    }
}
